const tagSelectorLocale = {
  placeholder: "Select a tag...",
  searchPlaceholder: "Search tags...",
  noOptionsAvailable: "No options available"
};
export {
  tagSelectorLocale
};
//# sourceMappingURL=en_US.js.map
